import { getPriceTriggers } from "../../../api/services/storeService";
import { logger } from "./../../../api/Logger.js";
import {
  validPriceTriggers,
  calculateWholeOrderDiscount,
  calculatePerItemDiscount,
  matchConditions,
  incAppliedQuantity,
  checkType,
} from "../../../api/helpers/priceTriggerHelpers";
import { validEarningLoyalityRoles } from "../../../api/helpers/LoyalityHelper.js";
import {
  validRedemptionRules,
  redemptionMatchConditions,
  calcSavedPoints,
} from "../../../api/helpers/redemptionRulesHelper.js";
import {
  RunType,
  OutcomeType,
  TriggerMode,
  priceTriggerType,
} from "../../../api/constants/priceTriggerEnums";
import store from "../../../store";
export default {
  state: {
    MenuEntity: {},
  },
  mutations: {
    setPriceTriggers(state, payload) {
      if (payload) {
        state.MenuEntity = payload;
        var priceTriggers = [];
        var loyaLities = [];
        var redemptionRules = [];
        if (payload.PriceTriggers) {
          for (let key in payload.PriceTriggers) {
            priceTriggers.push({ ...payload.PriceTriggers[key] });
          }
        }
        if (payload.EarningRules) {
          for (let key in payload.EarningRules) {
            loyaLities.push({ ...payload.EarningRules[key] });
          }
        }
        if (payload.RedemptionRules) {
          for (let key in payload.RedemptionRules) {
            redemptionRules.push({ ...payload.RedemptionRules[key] });
          }
        }

        state.MenuEntity.PriceTriggers = priceTriggers;
        state.MenuEntity.EarningRules = loyaLities;
        state.MenuEntity.RedemptionRules = redemptionRules;
        state.MenuEntity.MenuTimeSettings = payload.MenuTimeSettings;
      } else {
        state.MenuEntity = {
          PriceTriggers: [],
          EarningRules: [],
          RedemptionRules: [],
          MenuTimeSettings: [],
        };
      }
    },
    confirmPriceTrigger(state, payload) {
      state.priceTriggerConfirms[payload] = true;
    },
  },
  actions: {
    initPriceTriggers(context, payload) {
      getPriceTriggers(payload).onSnapshot(
        async function(doc) {
          if (doc.exists) {
            context.commit("setPriceTriggers", doc.data());
            context.dispatch("applyPriceTriggers");
          }
        },
        function(reason) {
          logger.log(
            reason.name,
            reason.toString(),
            "/initPriceTriggers/getPriceTriggers",
            logger.LogType.Error
          );
        }
      );
    },
    fixRollIntoQuantity(context) {
      context.state.MenuEntity.PriceTriggers.forEach((pt) => {
        var outcomeType = pt.OutcomeType;
        if (outcomeType && outcomeType >= 0) {
          for (const condition of pt.ProductCategoryConditions) {
            var totalAccur = 0;
            context.getters.cartItems.forEach((item) => {
              if (item.ProductCategoryIDs.includes(condition.ProductCategoryID))
                totalAccur += item.quantity;
            });
            var couldChoose = Math.floor(totalAccur / condition.Quantity);
            var selectedRollIntosQuantity = 0;
            context.getters.getPriceTriggerOutcomes
              .filter((p) => p.ID == pt.ID)
              .forEach((spt) => {
                var count = spt.selectedRollIntos
                  ? spt.selectedRollIntos.length
                  : 0;
                while (selectedRollIntosQuantity + count > couldChoose) {
                  spt.selectedRollIntos.pop();
                  count--;
                }
                selectedRollIntosQuantity += count;
              });
          }
          context.dispatch("applyPriceTriggers");
        }
      });
    },
    fixRedemptionQuantity(context) {
      while (
        context.getters.reedemptionLocalUsedPoints >
        context.getters.reedemptionPoints && context.getters.reedemptionPoints >=0
      ) {
        var cartItem = {
          ...context.getters.cartItems.find((p) => p.reedemptionRule),
        };
        context.commit("REMOVE_CART_ITEM", { item: cartItem });
      }
    },
  },
  getters: {
    getProductOutcomeInfo: (state, getters) => (productId) => {
      var product = getters.getProductById(productId);
      return product;
    },
    getProductInCategoryInfo: (state, getters) => (productId) => {
      for (var i = 0; i < getters.storeMenu.Categories.length; i++) {
        var p = getters.storeMenu.Categories[i];
        var subMenuItem = p.SubMenuItems.find((p) => p.ProductID == productId);
        if (subMenuItem) {
          subMenuItem.categoryId = p.ID;
          subMenuItem.categoryName = p.Name;
          return subMenuItem;
        }
      }
    },
    apllicablePriceTriggers(state, rootState) {
      var applicableTriggers = [];
      var isApplied = {};
      if (!state.MenuEntity.PriceTriggers) return [];
      var priceTriggers = validPriceTriggers(
        state.MenuEntity.PriceTriggers,
        rootState.used_coupons.length > 0,
        rootState.cartValue,
        rootState.currentStoreDoc
          ? rootState.currentStoreDoc.TimezoneIanaFormat
          : null
      );
      for (const priceTrigger of priceTriggers) {
        var shoppingcartItems = rootState.cartItems
          .filter((p) => !p.reedemptionRule)
          .sort((a, b) => {
            return a.Price - b.Price;
          });
        if (priceTrigger.IsMostExpensiveFirst) {
          shoppingcartItems = rootState.cartItems
            .filter((p) => !p.reedemptionRule)
            .sort((a, b) => {
              return b.Price - a.Price;
            });
        }
        for (const orderItem of shoppingcartItems) {
          var outcomeType = priceTrigger.OutcomeType;
          if (
            !outcomeType ||
            outcomeType == OutcomeType.OutcomeType_FromCategories ||
            outcomeType == OutcomeType.OutcomeType_FromTags
          ) {
            outcomeType = OutcomeType.OutcomeType_Default;
          }
          if (outcomeType >= 0) {
            //meet conditions
            var match = matchConditions(
              priceTrigger,
              orderItem,
              rootState.cartItems,
              isApplied[priceTrigger.ID] || 0
            );
            var allowToRun =
              (!isApplied[priceTrigger.ID] &&
                priceTrigger.RunType == RunType.RunOnce) ||
              priceTrigger.RunType == RunType.RunMultiple;
            if (match && allowToRun) {
              //check for whole order discounts
              if (
                outcomeType === OutcomeType.OutcomeType_Default &&
                priceTrigger.IsOutcomeLinkedToProduct == false &&
                priceTrigger.ProductCategoryConditions.length == 0 &&
                priceTrigger.ProductTagConditions.length == 0
              ) {
                incAppliedQuantity(isApplied, priceTrigger.ID);
                applicableTriggers.push({
                  order: orderItem.uniqueId,
                  type: priceTriggerType.wholeOrderDiscountPriceTriggers,
                  ...priceTrigger,
                  AppliedQuantity: isApplied[priceTrigger.ID],
                });
              } else if (
                outcomeType === OutcomeType.OutcomeType_Default &&
                (priceTrigger.ProductCategoryConditions.length != 0 ||
                  priceTrigger.ProductTagConditions.length != 0)
              ) {
                const type = checkType(priceTrigger.ProductCategoryConditions, priceTrigger.ProductTagConditions, orderItem);
                incAppliedQuantity(isApplied, priceTrigger.ID);
                applicableTriggers.push({
                  order: orderItem.uniqueId,
                  type,
                  ...priceTrigger,
                  AppliedQuantity: isApplied[priceTrigger.ID],
                });
                //TODO: per item discount
                //add order uniqueId to result object too
              } else if (outcomeType == OutcomeType.OutcomeType_Products) {
                if (
                  priceTrigger.TriggerMode == TriggerMode.TriggerWithConfirm &&
                  priceTrigger.IsOutcomeLinkedToProduct == true
                ) {
                  //check for roll into meal
                  incAppliedQuantity(isApplied, priceTrigger.ID);
                  applicableTriggers.push({
                    order: orderItem.uniqueId,
                    type: priceTriggerType.rollIntoMealPriceTriggers,
                    ...priceTrigger,
                    AppliedQuantity: isApplied[priceTrigger.ID],
                  });
                }
              }
            }
          }
        }
      }
      return applicableTriggers.sort((a, b) => {
        return a.Priority - b.Priority;
      });
    },
    canshowRollInto: (state, getters) => (orderItem, addQuantity = 0) => {
      var chooses = getters.getPriceTriggerOutcomes;
      if (!state.MenuEntity.PriceTriggers) return null;
      var priceTriggers = state.MenuEntity.PriceTriggers;
      for (const priceTrigger of priceTriggers) {
        var outcomeType = priceTrigger.OutcomeType;
        if (!outcomeType) {
          continue;
        }
        if (outcomeType >= 0) {
          //meet conditions
          var selectedRollIntosQuantity = 0;
          chooses
            .filter((p) => p.ID == priceTrigger.ID)
            .forEach((pt) => {
              selectedRollIntosQuantity += pt.selectedRollIntos
                ? pt.selectedRollIntos.length
                : 0;
            });
          var match = matchConditions(
            priceTrigger,
            orderItem,
            getters.cartItems,
            selectedRollIntosQuantity || 0,
            addQuantity
          );
          if (!match) {
            continue;
          } else if (matchConditions) {
            if (outcomeType == OutcomeType.OutcomeType_Products) {
              if (
                priceTrigger.TriggerMode == TriggerMode.TriggerWithConfirm &&
                priceTrigger.IsOutcomeLinkedToProduct == true
              ) {
                return {
                  ...priceTrigger,
                  ProductID: priceTrigger.ProductOutcomes[0].ProductID,
                  appliedDiscount: priceTrigger.FixedPriceValue,
                };
              }
            }
          }
        }
      }
    },
    //calculate results
    getPriceTriggerOutcomes(state, getters) {
      var outcomes = [];
      var totalDiscount = 0;
      for (let pt of getters.apllicablePriceTriggers) {
        if (pt.type == priceTriggerType.perCategoryDiscountPriceTriggers) {
          let orderItems = [];
          let appliedFor = '';
          let discountMultiplyBy = 1;
          if (pt.ProductCategoryConditions.length) {
            for (const condition of pt.ProductCategoryConditions) {
              const categoryID = condition.ProductCategoryID;
              // check if price trigger is already applied for this category
              const apt = outcomes.find(pt => pt.appliedFor === categoryID)
              if (!apt) {
                orderItems = getters.cartItems.filter((p) => p.ProductCategoryIDs.includes(categoryID));
                if (orderItems.length) {
                  const quantity = orderItems.reduce((total, orderItem) => total + orderItem.quantity, 0);
                  if(quantity >= condition.Quantity) {
                    discountMultiplyBy = pt.RunType === 2 ? Math.floor(quantity / condition.Quantity) : 1;
                    appliedFor = categoryID;
                  }
                }
              }
            }
          }
          if (pt.ProductTagConditions.length) {
            for (const condition of pt.ProductTagConditions) {
              const tagID = condition.ProductTagID;
              // check if price trigger is already applied for this tag
              const apt = outcomes.find(pt => pt.appliedFor === tagID)
              if (!apt) {
                orderItems = getters.cartItems.filter((p) => p.ProductTagIDs.includes(tagID));
                if (orderItems.length ) {
                  const quantity = orderItems.reduce((total, orderItem) => total + orderItem.quantity, 0);
                  if(quantity >= condition.Quantity) {
                    discountMultiplyBy = pt.RunType === 2 ? Math.floor(quantity / condition.Quantity) : 1;
                    appliedFor = tagID;
                  }
                }
              }
            }
          }
          if (appliedFor) {
            const cheapestItem = orderItems.reduce((min, item) => (item.price < min.price ? item : min), orderItems[0]);
            let perItemOrderDiscount = calculatePerItemDiscount(pt, cheapestItem);
            totalDiscount += perItemOrderDiscount;
            outcomes.push({
              ...pt,
              appliedDiscount: perItemOrderDiscount * discountMultiplyBy,
              appliedFor,
            });
          }
        }
        else if (pt.type == priceTriggerType.perItemDiscountPriceTriggers) {
          //TODO:per item dicount
          var orderitem = getters.cartItems.find((p) => p.uniqueId == pt.order);
          if (orderitem) {
            var perItemOrderDiscount = calculatePerItemDiscount(pt, orderitem);
            totalDiscount += perItemOrderDiscount;
            outcomes.push({
              ...pt,
              appliedDiscount: perItemOrderDiscount,
            });
          }
        } else if (
          pt.type == priceTriggerType.wholeOrderDiscountPriceTriggers
        ) {
          var wholeOrderDiscount = calculateWholeOrderDiscount(
            pt,
            getters.cartValue - getters.reedemptionValue,
            totalDiscount,
            getters.priceTriggerOutcomes
          );
          outcomes.push({
            ...pt,
            appliedDiscount: wholeOrderDiscount,
          });
        } else if (pt.type == priceTriggerType.rollIntoMealPriceTriggers) {
          var find = store.getters.priceTriggerOutcomes.find(
            (oc) => oc.order == pt.order && oc.ID == pt.ID
          );
          var selectedRollIntos = null;
          if (find) {
            selectedRollIntos = JSON.parse(
              JSON.stringify(find.selectedRollIntos)
            );
            if (selectedRollIntos)
              selectedRollIntos
                .filter((p) => p.isConfirmed && p.selectedModifiers)
                .forEach((rollInto) => {
                  rollInto.appliedDiscount = pt.FixedPriceValue;
                  rollInto.selectedModifiers.forEach((md) => {
                    rollInto.appliedDiscount += md.Price;
                  });
                });
          }
          outcomes.push({
            ...pt,
            selectedRollIntos,
            rollIntoProduct: {
              ...getters.getProductById(pt.ProductOutcomes[0].ProductID),
              ProductID: pt.ProductOutcomes[0].ProductID,
            },
          });
        }
      }
      return outcomes;
    },
    applicableLoyalityRule(state, rootState) {
      // if (process.env.NODE_ENV !== "production") return [];
      return rootState.applicableLoyalityRuleInternal;
    },
    applicableLoyalityRuleInternal(state, rootState) {
      if (!state.MenuEntity.EarningRules) return [];
      var LoyalityRolls = validEarningLoyalityRoles(
        state.MenuEntity.EarningRules,
        rootState.currentStoreDoc
          ? rootState.currentStoreDoc.TimezoneIanaFormat
          : null
      );
      return LoyalityRolls.sort((a, b) => {
        return b.DollarSpent - a.DollarSpent;
      });
    },

    canshowRedemption: (state, getters) => {
      var applicableRoll = null;
      if (!state.MenuEntity.RedemptionRules) return;
      var RedemptionRules = validRedemptionRules(
        state.MenuEntity.RedemptionRules,
        getters.currentStoreDoc
          ? getters.currentStoreDoc.TimezoneIanaFormat
          : null
      );
      var isMatch = true;
      for (var redemptionRule of RedemptionRules) {
        isMatch = redemptionMatchConditions(
          redemptionRule,
          getters.dbuser && getters.dbuser.RewardPoints
            ? getters.dbuser.RewardPoints
            : 0,
          getters.reedemptionLocalUsedPoints
        );
        if(isMatch && !getters.getProductById(redemptionRule.ProductVariant)){
          isMatch = false;
        }
        if (isMatch) {
          applicableRoll = redemptionRule;
          break;
        }
      }
      return applicableRoll;
    },
    getSavedPoints: (state, getters) => {
      if (!state.MenuEntity.RedemptionRules) return;
      var RedemptionRules = validRedemptionRules(
        state.MenuEntity.RedemptionRules,
        getters.currentStoreDoc
          ? getters.currentStoreDoc.TimezoneIanaFormat
          : null
      );
      var points = calcSavedPoints(
        RedemptionRules,
        getters.cartItems,
        state.MenuEntity.IsEarnPointsWhenRedeem
      );
      return points;
    },
    getFirstValidRedemptionRule: (state, getters) => {
      if (!state.MenuEntity.RedemptionRules) return null;
      var RedemptionRules = validRedemptionRules(
        state.MenuEntity.RedemptionRules,
        getters.currentStoreDoc
          ? getters.currentStoreDoc.TimezoneIanaFormat
          : null
      );
      if (RedemptionRules && RedemptionRules.length > 0)
        return RedemptionRules[0];
      else return null;
    },
    storeSupportsLoyaltyPoints: (state, getters) => {
      return (getters.getFirstValidRedemptionRule !== null
        || getters.getMenuEntity.PointsToDollarRatio > 0)
        && getters.applicableLoyalityRule.length > 0
        && getters.viewConfig.LogIn
        && getters.user == null;
    },
    getMenuEntity(state) {
      return state.MenuEntity;
    },
    useStampCollection(state, rootState) {
      if (state.MenuEntity.RedemptionRules) {
        var LoyaltyRules = validRedemptionRules(
          state.MenuEntity.RedemptionRules,
          rootState.currentStoreDoc
            ? rootState.currentStoreDoc.TimezoneIanaFormat
            : null
        );
        return LoyaltyRules.length > 0;
      } else return false;
    },

    getMenuTimeSettings(state) {
      return state.MenuEntity.MenuTimeSettings || [];
    },
    getMenuLifeStyles(state) {
      return state.MenuEntity.LifeStyleChoices || [];
    },
  },
};
